import React from 'react';
import { FiSearch } from 'react-icons/fi';
import { useThemeClasses } from '../../hooks/useThemeClasses';
import { formInputClass } from '../form';

/**
 * Barra unificada: búsqueda + filtros + contador de resultados.
 */
export default function AdminToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Buscar…',
  filters = null,
  meta,
  className = '',
}) {
  const tc = useThemeClasses();

  return (
    <div className={`rounded-2xl border p-3 sm:p-4 ${tc.box} ${className}`}>
      <div className="flex flex-col lg:flex-row gap-2.5 lg:items-center">
        <div className="relative flex-1 min-w-0">
          <FiSearch className={`absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 ${tc.textMuted}`} />
          <input
            type="search"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            className={`${formInputClass(tc.inputClass, { compact: true })} pl-9 w-full`}
          />
        </div>
        {filters ? <div className="flex flex-col sm:flex-row gap-2 lg:shrink-0">{filters}</div> : null}
      </div>
      {meta ? (
        <p className={`text-[11px] mt-2.5 ${tc.textMuted}`}>{meta}</p>
      ) : null}
    </div>
  );
}
